module.exports = __webpack_public_path__ + "static/media/modal-logo.68ad7720.svg";